import FamilyIcon from "@mui/icons-material/FamilyRestroomOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { useSpousalMaintenanceCalculator } from "@shared";

import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { SpousalMaintenanceCalculatorDialogProps } from "./SpousalMaintenanceCalculatorDialog.types";
import { TRANSLATION_BASE } from "./SpousalMaintenanceCalculatorDialog.utils";
import { SpousalMaintenanceCalculatorInputs } from "./components/SpousalMaintenanceCalculatorInputs";
import { SpousalMaintenanceCalculatorResult } from "./components/SpousalMaintenanceCalculatorResult";

export function SpousalMaintenanceCalculatorDialog({ onClose }: SpousalMaintenanceCalculatorDialogProps) {
  const { t } = useTranslation();
  const { formik, visibility, resultText } = useSpousalMaintenanceCalculator();

  const title = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <FamilyIcon color="primary" fontSize="large" />
      <Box>
        <Typography variant="h1">{t(`${TRANSLATION_BASE}.title`)}</Typography>
        <Typography variant="subtitle1" color="text.secondary">
          {t(`${TRANSLATION_BASE}.subtitle`)}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <FormDialog
      title={title}
      onClose={onClose}
      formik={formik}
      confirmDirtyClose={false}
      disableErrorNotification
      cancelLabel={t(`${TRANSLATION_BASE}.close`)}
      paperSx={{ maxWidth: "760px", width: "100%" }}
    >
      <Stack direction="row" gap={3}>
        <SpousalMaintenanceCalculatorInputs formik={formik} visibility={visibility} />
        <SpousalMaintenanceCalculatorResult visibility={visibility} resultText={resultText} />
      </Stack>
    </FormDialog>
  );
}
